import styled, { css } from 'styled-components';
import { blockTokens } from '../../../tokens/components/Block/tokens';
import { StyledButton } from '../../Button/Button';

export const BlockFooterWrapper = styled.div`
  border-top: ${blockTokens.CoreBorderStyle};
  padding: ${blockTokens.CoreSpacingBox};
  text-align: center;

  &::after,
  &::before {
    clear: both;
    content: '';
    display: table;
  }

  ${({ theme }) =>
    theme.mobile &&
    css`
      & ${StyledButton} {
        margin-bottom: 10px;
      }
    `}
`;
